package koala.model

import kampfire.model.GeoRect
import kampfire.model.GeoPoint
import kampfire.model.Point
import koala.external.Position
import koala.external.maplibregl
import kotlinx.browser.window

/** The point a fraction [t] of the way to [dest]. */
fun maplibregl.LngLat.interpolateTo(dest: maplibregl.LngLat, t: Double): maplibregl.LngLat =
    maplibregl.LngLat(
        lng = lng + (dest.lng - lng) * t,
        lat = lat + (dest.lat - lat) * t
    )

/** Animates the marker from [origin] to [destination] over [durationMs]. */
fun maplibregl.Marker.move(
    origin: maplibregl.LngLat,
    destination: maplibregl.LngLat,
    durationMs: Double = 1000.0,
) {
    var start: Double? = null

    fun tick(time: Double) {
        if (start == null) start = time
        val t = ((time - start) / durationMs).coerceIn(0.0, 1.0)
        setLngLat(origin.interpolateTo(destination, t))
        if (t < 1.0) window.requestAnimationFrame(::tick)
    }

    window.requestAnimationFrame(::tick)
}

fun Position.toLngLat() = maplibregl.LngLat(longitude.toDouble(), latitude.toDouble())
fun Position.toGeoPoint() = GeoPoint(lng = longitude.toDouble(), lat = latitude.toDouble())

fun maplibregl.LngLatBounds.toGeoBounds() = GeoRect(getSouthWest().toGeoPoint(), getNorthEast().toGeoPoint())
fun GeoRect.toLngLatBounds() = maplibregl.LngLatBounds(sw.toLngLat(), ne.toLngLat())

fun maplibregl.LngLat.toGeoPoint() = GeoPoint(lng = lng, lat = lat)

fun GeoPoint.toLngLat() = maplibregl.LngLat(lng = lng, lat = lat)

fun maplibregl.Point.toProjectedPoint() = Point(x = x, y = y)